export default __webpack_public_path__ + "static/media/1778.5a2ca5c7.png";